import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen bg-amf-navy flex items-center justify-center">
        <p className="amf-overline text-amf-gold">Loading…</p>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
